import { useMemo } from 'react';
import { useIntl } from 'react-intl';

export default function useListFormatter() {
  const { locale } = useIntl();

  const listFormatter = useMemo(
    () =>
      new Intl.ListFormat(locale, {
        style: 'long',
        type: 'conjunction',
      }),
    [locale],
  );

  return (list: string[]) => listFormatter.format(list);
}
